<style lang="scss" scoped>
</style>

<template>
  <CardIconPlusCallAction
    :href="href"
    component-action="a"
  >
    {{ __('Criar novo grupo') }}
  </CardIconPlusCallAction>
</template>

<script>
import CardIconPlusCallAction from '../ui/cards/CardIconPlusCallAction';

export default {
  name: 'CardCreateRole',

  components: {
    CardIconPlusCallAction,
  },

  props: {
    href: {
      type: String,
      required: true,
    },
  },
};
</script>
